import { useState } from "react";
import "./FAQ.css";

const faqData = [
  {
    question: "Where are you located?",
    answer:
      "I'm based in Glendale, California and serve clients throughout Los Angeles County."
  },
  {
    question: "Do you offer bridal makeup?",
    answer:
      "Yes, I specialize in bridal makeup, including bridal trials and wedding-day services."
  },
  {
    question: "Do you travel for weddings?",
    answer:
      "Yes, I am available to travel for weddings and special events upon request."
  },
  {
    question: "How far in advance should I book?",
    answer:
      "For weddings, I recommend booking at least 3-6 months in advance to secure your date."
  },
  {
    question: "Do you offer makeup trials?",
    answer:
      "Yes, makeup trials are available and highly recommended for brides before the wedding day."
  },
  {
    question: "Do you offer regular makeup services?",
    answer:
      "Yes, I provide regular makeup services for everyday occasions, photoshoots, and special events."
  },
  {
    question: "What are your prices for makeup services?",
    answer:
      "My makeup services range from $150 to $400, depending on the type of service and event. Please contact me for a personalized quote."
  },
  {
    question: "Who is Anahit?",
    answer:
      "Anahit is a professional makeup artist based in Glendale, California, specializing in bridal and special occasion makeup with years of experience creating beautiful looks for her clients."
  },
  {
    question: "Do you have experience working with celebrities?",
    answer:
      "Yes, I have had the privilege of working with several celebrity clients, providing professional makeup services for events, photoshoots, and appearances."
  },
  {
    question: "What types of makeup products do you use?",
    answer:
      "I use high-quality, professional-grade, hypoallergenic makeup products suitable for all skin types, including cruelty-free and vegan options upon request."
  },
  {
    question: "How long does a typical makeup session last?",
    answer:
      "A regular makeup session usually lasts between 45 minutes to 1.5 hours depending on the service."
  },
  {
    question: "Do you offer makeup services for non-bride special occasions?",
    answer:
      "Yes, I provide makeup services for special occasions, photo shoots, and any event where you want to look your best."
  },
  {
    question: "What is your cancellation or rescheduling policy?",
    answer:
      "I require at least 48 hours notice for cancellations or rescheduling to avoid fees."
  },
  {
    question: "Can you do makeup for large bridal parties?",
    answer:
      "Yes, I can accommodate bridal parties of all sizes. Please contact me early to ensure availability."
  },
  {
    question: "Do you provide on-location makeup services?",
    answer:
      "Yes, I travel to homes, hotels, and event venues in Glendale and the greater Los Angeles area."
  },
  {
    question: "Do you offer hair styling services as well?",
    answer:
      "Currently, I specialize in makeup services only, but I work closely with trusted hairstylists and can provide recommendations."
  },
  {
    question: "How do I prepare for my makeup appointment?",
    answer:
      "Arrive with a clean, moisturized face and avoid applying heavy skincare products or other makeup."
  },
  {
    question: "Do you offer group or package deals?",
    answer:
      "Yes, I offer special rates for bridal parties and group bookings. Please contact me for details."
  },
  {
    question: "How do I book an appointment?",
    answer:
      "You can book via my website, Instagram direct message, or email at thefacebyanahit@gmail.com."
  }
];


const FAQ = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAnswer = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  return (
    <>
      {/* Trigger Button */}
      <button className="faq-open-btn" onClick={() => setIsOpen(true)} aria-haspopup="dialog" aria-expanded={isOpen} aria-controls="faq-modal">
        Frequently Asked Questions
      </button>

      {/* Modal */}
      {isOpen && (
        <div className="faq-overlay" onClick={() => setIsOpen(false)}>
          <div
            className="faq-modal"
            onClick={(e) => e.stopPropagation()}
            role="dialog"
            aria-modal="true"
            aria-labelledby="faq-title"
          >
            <button className="faq-close-btn" onClick={() => setIsOpen(false)} aria-label="Close FAQ dialog">
              x
            </button>

            <h2 id="faq-title" className="faq-modal-title">Frequently Asked Questions</h2>

            <hr/>

            {faqData.map((item, index) => (
              <div className="faq-item" key={index}>
                <button
                  className="faq-question"
                  onClick={() => toggleAnswer(index)}
                  aria-expanded={activeIndex === index}
                >
                  {item.question}
                  <span className="faq-icon">
                    {activeIndex === index ? "-" : "+"}
                  </span>
                </button>

                {activeIndex === index && (
                  <div className="faq-answer">{item.answer}</div>
                )}
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default FAQ;
